<template>
    <div>
        <v-form ref="editForm" v-model="valid" @submit="save" @submit.prevent>
            <v-card>
                <v-card-title>
                    <span class="headline">{{ mode }} OAuth Client</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field v-model="item.clientName" label="Client Name" :rules="clientNameRules" :readonly="readOnly" required :counter=100 />
                    <v-text-field v-model="item.websiteUrl" label="Website Url" :rules="websiteUrlRules" :readonly="readOnly" required :counter=2000 />
                    <file-upload :value="item.logoFileId" @input="onFileUploaded" label="Logo File" />
                    <img v-if="hasLogoFileId" :src="fileUrl" style="max-width:400px;max-height:300px;" />
                    <v-text-field v-if="isEdit" v-model="item.clientIdentifier" label="Client Identifier" :readonly="true" />
                    <div v-if="isEdit">{{ clientSecretState }}</div>
                    <div v-if="isEdit" class="v-messages__wrapper"></div>
                    <v-btn v-if="isEdit" @click="newClientSecret">New Client Secret</v-btn>
                    <oauth-client-redirect-uris-table :key="item.id" v-if="isEdit" :clientId="item.id" />
                </v-card-text>

                <v-card-actions>
                    <v-btn v-if="isEdit && !hideDelete" color="quinary" text @click="deleteItem" :disabled="readOnly">Delete</v-btn>
                    <div class="flex-grow-1"></div>
                    <v-btn color="quaternary" text @click="cancel">Cancel</v-btn>
                    <v-btn type="submit" color="quaternary" text :disabled="readOnly">{{ saveTitle }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
        <v-dialog v-model="newClientSecretDialogVisible" max-width="750px">
            <v-form>
                <v-card>
                    <v-card-title>
                        <span class="headline">New Client Secret</span>
                    </v-card-title>
                    <v-card-text>
                        <div>This is your new client secret, make a copy of this value now it cannot be retreived after closing this dialog</div>
                        <div>{{ newClientSecretValue }}</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="quaternary" text @click="closeNewClientSecretValue" ::readonly="true">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import errorUtility from '../../services/errorUtility'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            oauthClientRedirectUrisTable: () => import('../tables/OauthClientRedirectUrisTable'),
            fileUpload: () => import('../../components/FileUpload')
        },

        data() {
            return {
                valid: true,
                readOnly: false,
                fileForm: () => import('../../forms/FileForm'),
                apiMethod: 'OauthClients',
                clientNameRules: [v => !!v || 'Client Name is required', v => !(v && v.length > 100) || 'Client Name must be less than 100 characters'], 
                websiteUrlRules: [v => !!v || 'Website Url is required', v => !(v && v.length > 2000) || 'Website Url must be less than 2000 characters'], 
                item: {},
                isSaving: false,
                hasClientSecret: false,
                isAdding: false,
                newClientSecretValue: "",
                isDeleting: false,
                isCreatePressed: false
            }
        },
        async mounted() {
            if (this.value === null || typeof this.value === "undefined") {
                return;
            }
            var response = await axios.get('/api/' + this.apiMethod + '/' + this.value.id);
            this.item = response.data;
            let params = {
                clientId: this.value.id
            }
            response = await axios.get('/api/OauthClientSecrets/', { params });
            this.hasClientSecret = response.data.total > 0;
        },
        methods: {
            onInput() {
                // When save is pressed on an add item screen
            },
            async save() {
                if (this.isSaving) { return; }
                if (!this.$refs.editForm.validate()) { return; }
                this.isSaving = true;
                var item = Object.assign({}, this.item);
                this.removeEmptyStringOrObjectsFromArray(item);
                try {
                    var isEdit = this.isEdit;
                    var response = await (isEdit ?
                        axios.put('/api/' + this.apiMethod + '/', item) :
                        axios.post('/api/' + this.apiMethod + '/', item));

                    this.item = response.data;
                    if (isEdit) {
                        this.$emit('input', this.item);
                        this.$emit(isEdit ? 'update' : 'add', this.item);
                    }
                    this.isCreatePressed = true;
                } catch (error) {
                    this.$emit('open');
                    errorUtility.handleServerError(error);
                }
                finally {
                    this.isSaving = false;
                }
            },
            async cancel() {
                this.$emit('close');
                this.$emit('cancel');
            },
            async deleteItem() {
                if (this.isDeleting) { return; }
                if (confirm("Are you sure you want to delete this Oauth client?")) {
                    this.isDeleting = true;
                    try {
                        //let params = { id: this.item.id };
                        await axios.delete('/api/' + this.apiMethod + '/' + this.item.id);

                        this.$emit('input', this.item);
                        this.$emit('delete', this.item);
                    } catch (error) {
                        this.$emit('open');
                        errorUtility.handleServerError(error);
                    }
                    finally {
                        this.isDeleting = false;
                    }
                }
            },
            async newClientSecret() {
                if (this.isAdding) { return; }
                if (!this.$refs.editForm.validate()) { return; }
                this.isAdding = true;
                try {
                    let params = { clientId: this.item.id };
                    var response = await axios.post('/api/OauthClientSecrets/', params);

                    this.newClientSecretValue = response.data;
                    this.hasClientSecret = true;
                } catch (error) {
                    this.$emit('open');
                    errorUtility.handleServerError(error);
                }
                finally {
                    this.isAdding = false;
                }
            },
            closeNewClientSecretValue() {
                this.newClientSecretValue = "";
            },
            onFileUploaded(fileId) {
                this.item.logoFileId = fileId;
            }
        },
        computed: {
            isEdit() {
                return this.value !== null && this.value !== undefined || this.isCreatePressed;
            },
            mode() {
                return this.isEdit ? 'Edit' : 'Add';
            },
            saveTitle() {
                return this.isEdit ? 'Save' : 'Create';
            },
            clientSecretState() {
                return this.hasClientSecret ? "Client secret has been set" : "No client secret has been set";
            },
            newClientSecretDialogVisible() {
                return this.newClientSecretValue != "";
            },
            fileUrl() {
                if (this.item.hasOwnProperty("logoFileId")) {
                    return `/api/Files/GetFile/${this.item.logoFileId}`;
                } else {
                    return "";
                }
            },
            hasLogoFileId() {
                return this.item.logoFileId !== null && typeof this.item.logoFileId !== "undefined";
            },
        }
    };
</script>
